module.exports = __webpack_public_path__ + "img/om.b6771181.svg";